import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  tooltip,
  stroke,
  lineXaxis,
  DownloadButton,
} from '../options';
import { convertTZ, getDatesRange } from '../utils';

import dict from '../../dictionary';
import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import { Checkbox } from 'antd';
import '../buttonGroup/buttonGroup.scss';
import compareChartColours from '../compareChart/compareChart.scss';
import './bySourceSetting.scss';
import { SelectionLimitReached } from '../compareChart/compareChartUtils';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

const chartColours = [
  compareChartColours.compareChartColour1,
  compareChartColours.compareChartColour2,
  compareChartColours.compareChartColour3,
  compareChartColours.compareChartColour4,
  compareChartColours.compareChartColour5,
];

const sourcesToDisplay = {
  groupCare: [
    dict.sourcesSetting['1 Long-Term Care Homes'],
    dict.sourcesSetting['2 Hospitals'],
    dict.sourcesSetting['3 Retirement Homes'],
  ],
  groupLiving: [
    dict.sourcesSetting['4 Group Home/Supportive Housing'],
    dict.sourcesSetting['5 Correctional Facility'],
    dict.sourcesSetting['6 Shelter'],
    dict.sourcesSetting['18 Short-term accommodations'],
    dict.sourcesSetting['22 Congregate other'],
  ],
  groupEducation: [
    dict.sourcesSetting['11 Child care'],
    dict.sourcesSetting['7 School - Elementary'],
    dict.sourcesSetting['8 School - Secondary'],
    dict.sourcesSetting['9 School - Elementary/Secondary'],
    dict.sourcesSetting['10 School - Post-Secondary'],
  ],
  groupRecreational: [
    dict.sourcesSetting['17 Bar/restaurant/nightclub'],
    dict.sourcesSetting['19 Recreational fitness'],
    dict.sourcesSetting['20 Personal service settings'],
    dict.sourcesSetting['21 Other recreation'],
  ],
  groupWorkplace: [
    dict.sourcesSetting['12 Workplace - Farm'],
    dict.sourcesSetting['13 Workplace - Food Processing'],
    dict.sourcesSetting['15 Retail'],
    dict.sourcesSetting['16 Medical/Health Service'],
    dict.sourcesSetting['14 Workplace - Other'],
  ],
  groupOther: [
    dict.sourcesSetting['24 Unknown'],
    dict.sourcesSetting['23 Other'],
  ],
};
const latestDate = Object.keys(
    ReducedData.dataSourceAll[dict.sourcesAll['CC']],
  )
    .sort((a, b) => new Date(a) - new Date(b))
    .pop(),
  dateRange = getDatesRange('2020-01-15', latestDate);

//console.log("dateRange", dateRange);

class BySourceSettingGraph extends Component {
  state = {
    ready: false,
    keys: Object.values(dict.sourcesSetting),
    selection: [
      dict.sourcesSetting['1 Long-Term Care Homes'],
      dict.sourcesSetting['4 Group Home/Supportive Housing'],
      dict.sourcesSetting['11 Child care'],
      dict.sourcesSetting['17 Bar/restaurant/nightclub'],
      dict.sourcesSetting['12 Workplace - Farm'],
    ],
    selectionColors: chartColours,
    series: [],
    selectionLimitReached: false,
    options: {},
    selectedViewMode: viewModes.graph,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selection !== prevState.selection ||
      this.props.selectedTab !== prevProps.selectedTab
    ) {
      this.setData();
    }
  }

  zeroSelection = () => {
    this.setState({
      selectionLimitReached: false,
      selection: [null, null, null, null, null],
    });
  };

  toggleSelection = (name) => {
    var selection = [...this.state.selection];
    //check if it's already selected
    var currentSelectionKey = selection.indexOf(name);
    var availColour = selection.indexOf(null);

    if (currentSelectionKey !== -1) {
      selection[currentSelectionKey] = null;
    } else if (availColour !== -1) {
      selection[availColour] = name;
    }

    const newSelectionColors = chartColours.filter(
      (color, ind) => selection[ind],
    );

    this.setState({
      selectionLimitReached:
        currentSelectionKey === -1 && availColour === -1,
      selection: selection,
      selectionColors: newSelectionColors,
    });
  };

  setData = () => {
    let show = Boolean(
      this.state.selection.reduce((sum, sel) => sum + sel),
    );
    var series = [...this.state.selection]
      .filter((item) => item)
      .map((name, z) => {
        var sourceName = name;
        //console.log(sourceName, ReducedData.dataSourceSetting[sourceName]);
        var accum = 0;
        return {
          name:
            trans.activeOutbreaks[
              Object.keys(dict.sourcesSetting)[
                Object.values(dict.sourcesSetting).indexOf(name)
              ]
            ][this.props.lang],
          data: [...dateRange].map((date, x) => {
            const newDate = convertTZ(
              date + 'T00:00:00',
              'America/Toronto',
            ).getTime();
            var value =
                (ReducedData.dataSourceSetting[sourceName] &&
                  ReducedData.dataSourceSetting[sourceName][
                    x !== 0 && dateRange[x - 1] + 'T00:00:00'
                  ]) ||
                0,
              result;

            // if (!value) {
            //   console.log("object", value, sourceName, date, newDate);
            // }

            accum = accum + value;

            switch (this.props.selectedTab) {
              case 'newCases':
                result = value;
                break;
              case 'totalCases':
                result = accum;
                break;
              default:
                break;
            }

            return [newDate, result];
          }),
        };
      });

    series.forEach((item) =>
      item.data.sort((a, b) => new Date(a[0]) - new Date(b[0])),
    );
    // console.log(series);

    this.setState({
      series: [...series],
      options: {
        colors: this.state.selectionColors,
        markers: {
          size: 0,
          strokeColors: '#fff',
          strokeWidth: 1,
          hover: {
            size: 9,
          },
        },
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: tooltip,
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.bySource.yaxis[this.props.lang],
          },
          decimalsInFloat: 0,
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: {
          ...lineXaxis(show),
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                animations: {
                  enabled: false,
                  animateGradually: {
                    enabled: false,
                  },
                  dynamicAnimation: {
                    enabled: false,
                  },
                },
                offsetX: 10,
                height: '200px',
                toolbar: {
                  tools: {
                    zoomin: false,
                    zoomout: false,
                  },
                },
              },
              xaxis: {
                labels: {
                  hideOverlappingLabels: true,
                },
              },
              legend: {
                fontSize: '10px',
              },
              dataLabels: {
                enabled: false,
              },
            },
          },
        ],
        // fill: {
        //   opacity: [0.2, 1],
        // },
      },
      ready: true,
    });
  };

  render() {
    const CheckboxesNames = (props) =>
      sourcesToDisplay[props.group].map((item, key) => {
        var selectionKey = this.state.selection.includes(item)
          ? `compare-chart-${this.state.selection.indexOf(item)}`
          : '';
        return (
          <Checkbox
            checked={this.state.selection.includes(item)}
            onClick={() => this.toggleSelection(item)}
            className={`${selectionKey}`}
            key={key + Math.round(Math.random() * 1000000)}
          >
            {
              trans.activeOutbreaks[
                Object.keys(dict.sourcesSetting)[
                  Object.values(dict.sourcesSetting).indexOf(item)
                ]
              ][this.props.lang]
            }
          </Checkbox>
        );
      });

    return (
      <div
        id="byLikelySourceGraph"
        className="chart ontario-margin-top-16-! ontario-margin-bottom-8-! "
      >
        {this.state.ready ? (
          <>
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              height={400}
              aria-hidden="true"
            />
            <p>{trans.bySource.selectSetting[this.props.lang]}</p>
            <div className="ontario-row">
              {Object.keys(sourcesToDisplay)
                .filter((item, i) => i < 3)
                .map((group, i) => {
                  return (
                    <div
                      className="ontario-column ontario-small-12 ontario-medium-4  setting-section"
                      key={i}
                    >
                      <h6 >
                        {
                          trans.activeOutbreaks[group][
                            this.props.lang
                          ]
                        }
                      </h6>
                      <CheckboxesNames group={group} />
                    </div>
                  );
                })}
            </div>
            <div className="ontario-row">
              {Object.keys(sourcesToDisplay)
                .filter((item, i) => i > 2)
                .map((group, i) => {
                  return (
                    <div
                      className="ontario-column ontario-small-12 ontario-medium-4  setting-section"
                      key={i + 3}
                    >
                      <h6 >
                        {
                          trans.activeOutbreaks[group][
                            this.props.lang
                          ]
                        }
                      </h6>
                      <CheckboxesNames group={group} />
                    </div>
                  );
                })}
            </div>
            <SelectionLimitReached
              lang={this.props.lang}
              visible={this.state.selectionLimitReached}
              onOk={() =>
                this.setState({ selectionLimitReached: false })
              }
              onCancel={this.zeroSelection}
              text={trans.bySource.modalText[this.props.lang]}
              title={trans.bySource.modalTitle[this.props.lang]}
            />
          </>
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default BySourceSettingGraph;
